//Firebase Configuration
const firebaseConfig = {
  apiKey: "AIzaSyCKPRHlrYVGUpl97Vpr_xEc6IL1vJOVJLU",
  authDomain: "smpw-masters.firebaseapp.com",
  projectId: "smpw-masters",
  storageBucket: "smpw-masters.firebasestorage.app",
  messagingSenderId: "997276036776",
  appId: "1:997276036776:web:025def45eb78ff509d5c9d",
  measurementId: "G-8QHTEP3Q66"
};

export default firebaseConfig;